"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTaskHealthApplicable = void 0;
/**
 * Health checks apply to manual tasks that are live (in preview or submitted).
 * Autotransform tasks (`taskType` AUTO) are server-side and have no worker-facing health to report.
 */
const isTaskHealthApplicable = (task) => (task.status === 'PREVIEW' || task.status === 'LIVE') && task.params.taskType !== 'AUTO';
exports.isTaskHealthApplicable = isTaskHealthApplicable;
//# sourceMappingURL=Health.js.map